export const onGetFormatNumber = (number) => {
    let result = ''
    if(number){
        let temp = parseFloat(number).toFixed(0)
        result = temp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return result
}